import { IonButton, IonContent, IonItem, IonModal, IonTitle, useIonRouter } from '@ionic/react';
import { useState } from 'react';
import { useNamedRoutes } from '../../../../../NamedRoutes';
import { useCreateSystemShare, useSystem } from '../../../../../ReactData/system';
import SettingsLabel from '../../../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel';
import UserTypeAhead from '../../../../../User/UserTypeAhead';
import { NewShareProps } from './types';
import { useL10n } from '@ews/react-localization-context';
import SettingsTextInput from '../../../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput';
import { useInvokeCreateSystemShare } from '../../../../../ReactData/rpc';


import type { User } from "@ews/react-data";

const NewShare: React.FC<NewShareProps> = ({ isOpen, onClose, systemId }) =>
{

    /* 
    
    für Anlagen-ID *        LABEL
    Benutzer-ID *           INPUT
    E-Mail *                INPUT
    
    Dauer der Freigabe *    INPUT "Stunden"                 
    Unbegrenzte Freigabe    CHECKBOX
    Alle Benutzer           CHECKBOX
    Informieren vor Ablauf  CHECKBOX
    
    */

    const { generate } = useNamedRoutes();
    const { translate: t } = useL10n();
    const router = useIonRouter();
    const createShare = useCreateSystemShare();
    const [userId, setUserId] = useState("");
    const system = useSystem(systemId || "");

    const [userEmail, setUserEmail] = useState("");
    const [userName, setUserName] = useState("");
    // const [userEmail, setUserEmail] = useState("philipp.tiefenbacher@lst.at");
    // const [userName, setUserName] = useState("18833");

    const invokeCreateShare = useInvokeCreateSystemShare();

    const createShareAndRedirect = async () =>
    {
        const share = await createShare(systemId!, userId!);
        const link = generate('system:share-settings', { id: share.systemId, userId: share.userId });
        router.push(link);
    };

    const invokeCreateShareAndRedirect = async () =>
    {
        const response = await invokeCreateShare({systemId: systemId!, username: userName, email: userEmail } );
        if (response) {
            const link = generate('system:share-settings', { id: response.systemShareId.systemId, userId: response.systemShareId.userId });
            router.push(link);
        }
    };

    const onSelectUser = async (userId: string, user: User) => {
        setUserId(userId);
        setUserEmail(user.email!);
        setUserName(user.username!);
    };

    return <IonModal
        isOpen={isOpen}
        onDidDismiss={() => onClose()}
    >
        <IonItem color={"primary"} lines='none'>
            <IonTitle>{t("COM_FACPMANAGEMENT_SHARE_ADD_NEW")}</IonTitle>
        </IonItem>
        <IonContent>
            <SettingsLabel text={"[REACT_FOR_SYSTEM]"} value={system.name} />
            <UserTypeAhead
                label="COM_FACPMANAGEMENT_SHARE_ADD_NEW"
                onChange={onSelectUser}
            />
            <SettingsTextInput
                inputType="text"
                text={"COM_FACPMANAGEMENT_USERS_USERID"}
                value={userName}
                onChange={setUserName} />
            <SettingsTextInput
                inputType="email"
                text={"COM_CONTACT_EMAIL_LABEL"}
                value={userEmail}
                onChange={setUserEmail} />
            <IonButton
                disabled={!userEmail || !userName}
                color={"success"}
                onClick={invokeCreateShareAndRedirect}
            >{t("COM_FACPMANAGEMENT_SHARE_ADD_NEW")}</IonButton>

            {/* <IonButton
                disabled={!userId}
                color={"success"}
                onClick={() => createShareAndRedirect()}
            >{t("COM_FACPMANAGEMENT_SHARE_ADD_NEW")}</IonButton>
            */}
        </IonContent>
    </IonModal>;
};
export default NewShare;
